export default () => ({
  paymentContracts: []
})
